import { getComponent } from '../utils'
import { h } from 'vue'
import { prefix } from '../prefix'
import Layout from '@/layouts/main-layout.vue'
import { RoleGuard } from '../guards'
import { ControlOutlined, TagsOutlined } from '@ant-design/icons-vue'
import type { RouteRecordRaw } from 'vue-router'

export const super_admin_routes: RouteRecordRaw[] = [
  {
    path: '/plans',
    name: 'plans',
    component: () => getComponent(`pages/plans.vue`),
    meta: {
      title: () => 'Plans',
      layout: Layout,
      is_public: false,
      guard: RoleGuard(['super_admin']),
      menu: {
        key: 'Plans',
        label: 'Plans',
        icon: () => h(TagsOutlined),
        path: `${prefix}/plans`,
      },
    },
  },
  {
    path: '/controls',
    name: 'controls',
    component: () => getComponent(`pages/controls.vue`),
    meta: {
      title: () => 'Controls',
      layout: Layout,
      is_public: false,
      guard: RoleGuard(['super_admin']),
      menu: {
        key: 'Controls',
        label: 'Controls',
        icon: () => h(ControlOutlined),
        path: `${prefix}/controls`,
      },
    },
  },
]
